<template>
    <v-container fluid>
        <template>
            <v-card class="mb-5">
                <v-tabs v-model="tab">
                    <v-tab>
                        Parceiro
                    </v-tab>
                    <v-tab>
                        Clientes
                    </v-tab>
                    <v-tab>
                        Usuários
                    </v-tab>
                </v-tabs>

                <card-header
                    :title="$t('partner.breadcrumbs.show')"
                    v-if="tab == 0"
                >
                </card-header>

                <v-card-text v-if="tab == 0">
                    <v-row v-if="!reseller">
                        <v-col class="text-center">
                            <v-progress-circular
                                :size="50"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                    <template v-else>
                        <v-row>
                            <v-col>
                                <v-card class="grey lighten-4">
                                    <v-card-text class="py-2">
                                        <div>{{ reseller.legal_name }}</div>

                                        <v-row no-gutters>
                                            <v-col>
                                                <span
                                                    class="headline text--primary"
                                                >
                                                    {{ reseller.trade_name }}
                                                </span>
                                            </v-col>
                                            <v-col>
                                                <div
                                                    class="text-right subtitle-1"
                                                >
                                                    <strong>CNPJ: </strong>
                                                    {{ reseller.document }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-text class="py-2 d-flex">
                                        <span>
                                            <v-icon small left
                                                >mdi-phone</v-icon
                                            >
                                            {{ reseller.phone }}
                                        </span>

                                        <v-divider
                                            class="mx-4"
                                            vertical
                                        ></v-divider>

                                        <span>
                                            <v-icon small left
                                                >mdi-email</v-icon
                                            >
                                            {{ reseller.email }}
                                        </span>

                                        <v-divider
                                            class="mx-4"
                                            vertical
                                        ></v-divider>

                                        <v-btn
                                            elevation="0"
                                            x-small
                                            @click="downloadCsv(reseller)"
                                        >
                                            <v-icon small left>
                                                mdi-file-chart-outline
                                            </v-icon>
                                            {{
                                                $t(
                                                    'partner.form.actions.reports',
                                                )
                                            }}
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="2" sm="12">
                                <v-card class="text-center grey lighten-4">
                                    <card-header
                                        :showBackButton="false"
                                        :title="
                                            $tc('resources.category.name', 1)
                                        "
                                        class="justify-center"
                                    />

                                    <v-card-text>
                                        <CategoryBadge
                                            :category="reseller.category"
                                            cardClass="grey lighten-4"
                                            :showCommission="!reseller.billable"
                                            :showDiscount="reseller.billable"
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col
                                v-if="reseller.bankAccountActive.agency"
                                cols="3"
                            >
                                <v-card
                                    class="grey lighten-4 bank-account-partner"
                                >
                                    <v-card-text class="py-2">
                                        <v-row no-gutters>
                                            <v-col class="mb-3">
                                                <v-icon small left>
                                                    mdi-bank
                                                </v-icon>
                                                {{
                                                    $t(
                                                        'bank-account.breadcrumbs.index',
                                                    )
                                                }}
                                            </v-col>
                                            <v-col cols="1">
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            align-self="center"
                                                            elevation="0"
                                                            x-small
                                                            v-on="on"
                                                            :to="{
                                                                name: $t(
                                                                    'bank-account.routes.index',
                                                                ),
                                                                params: {
                                                                    reseller_id:
                                                                        reseller.id,
                                                                },
                                                            }"
                                                        >
                                                            <v-icon small>
                                                                mdi-eye
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{
                                                        $t(
                                                            'bank-account.tooltip.see-all',
                                                        )
                                                    }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        <v-card
                                            tile
                                            class="grey lighten-4 bank-account-partner"
                                            elevation="0"
                                        >
                                            <span class="caption">
                                                {{
                                                    $t(
                                                        'bank-account.index.table.bank',
                                                    )
                                                }}:
                                            </span>
                                            <span
                                                class="body-2 font-weight-medium"
                                            >
                                                {{
                                                    reseller.bankAccountActive
                                                        .bankName
                                                }}
                                            </span>
                                            <br />
                                            <span class="caption">
                                                {{
                                                    $t(
                                                        'bank-account.index.table.bank-code',
                                                    )
                                                }}:
                                            </span>
                                            <span class="body-2">{{
                                                reseller.bankAccountActive
                                                    .bankCode
                                            }}</span>
                                            <br />
                                            <span class="caption">
                                                {{
                                                    $t(
                                                        'bank-account.index.table.agency',
                                                    )
                                                }}:
                                            </span>
                                            <span class="body-2">{{
                                                reseller.bankAccountActive
                                                    .agency
                                            }}</span>
                                            <br />
                                            <span class="caption">
                                                {{
                                                    $t(
                                                        'bank-account.index.table.account-number',
                                                    )
                                                }}:
                                            </span>
                                            <span class="body-2">{{
                                                reseller.bankAccountActive
                                                    .account_number
                                            }}</span>
                                            <template
                                                v-if="
                                                    reseller.bankAccountActive
                                                        .pix
                                                "
                                            >
                                                <br />
                                                <span class="caption">
                                                    {{
                                                        $t(
                                                            'bank-account.index.table.pix',
                                                        )
                                                    }}:
                                                </span>
                                                <span class="body-2">{{
                                                    reseller.bankAccountActive
                                                        .pix
                                                }}</span>
                                            </template>
                                        </v-card>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-divider
                                v-if="
                                    reseller.addresses.length &&
                                        reseller.bankAccountActive.agency
                                "
                                class="mx-4"
                                vertical
                            ></v-divider>

                            <v-col v-if="reseller.addresses.length">
                                <v-card
                                    class="grey lighten-4 bank-account-partner"
                                >
                                    <v-card-text class="py-2">
                                        <v-row no-gutters>
                                            <v-col class="mb-3"
                                                ><v-icon small left>
                                                    mdi-map-marker
                                                </v-icon>
                                                {{
                                                    $t(
                                                        'partner.show.texts.addresses',
                                                    )
                                                }}
                                            </v-col>
                                        </v-row>
                                        <v-card
                                            class="d-flex justify-start grey lighten-4"
                                            elevation="0"
                                        >
                                            <v-card
                                                tile
                                                elevation="0"
                                                class="addresses-partner"
                                                v-for="(address,
                                                key) in reseller.addresses"
                                                :key="'add_' + key"
                                                >{{ address.readableAddress }}
                                                <br />
                                                {{ address.readableCity }}
                                                <br />
                                                {{ address.zip_code }}
                                            </v-card>
                                        </v-card>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>

                <v-card-text v-if="tab == 1">
                    <Customers :customers="reseller.customers" />
                </v-card-text>

                <v-card-text v-if="tab == 2">
                    <ResellerUserIndex :reseller_id="id" />
                </v-card-text>
            </v-card>
        </template>

        <v-row v-if="indicators.length > 0">
            <v-col>
                <indicator-group
                    icon="mdi-account-tie"
                    :label="indicators[0].label"
                    :indicators="indicators[0]"
                />
            </v-col>

            <v-col>
                <indicator-group
                    icon="mdi-account-tie"
                    :label="indicators[1].label"
                    :indicators="indicators[1]"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import CategoryBadge from '@/shared/components/CategoryBadge'
import Customers from './Customers'
import IndicatorGroup from '@/components/indicators/IndicatorGroup'
import ResellerModel from '@/models/Reseller'
import ResellerUserIndex from '@/views/resellerUser/Index'

export default {
    components: {
        CardHeader,
        CategoryBadge,
        Customers,
        IndicatorGroup,
        ResellerUserIndex,
    },

    props: ['id'],

    data: () => {
        return {
            reseller: null,
            tab: null,
        }
    },

    methods: {
        async getReseller() {
            let reseller = await this.model.find(this.id)
            this.reseller = reseller
        },

        async downloadCsv(item) {
            let res = await this.$http.get('reports/reseller/' + item.id, {
                responseType: 'blob',
            })

            if (!res) return

            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'reseller-report.csv')
            document.body.appendChild(link)
            link.click()
        },
    },

    computed: {
        model() {
            return new ResellerModel()
        },
        indicators() {
            if (!this.reseller) return []

            return [
                [
                    {
                        type: 'plain',
                        label: 'Clientes Ativos',
                        value: parseInt(
                            this.reseller.indicators.activeCustomers,
                        ),
                    },
                ],
                [
                    {
                        type: 'plain',
                        label: 'MMR',
                        value: this.$n(
                            parseFloat(this.reseller.indicators.mmr),
                            'currency',
                            2,
                        ),
                    },
                ],
            ]
        },
    },

    created() {
        this.getReseller()
    },
}
</script>
